module.exports = __webpack_public_path__ + "static/media/dwellPass-logo-white-800w.07718989.png";